export const salesOrderQuery = (maskId) => `
        {
        salesOrder(masked_id: "${maskId}") {
         billing_address {
            city
            street
            company
            country_code
            fax
            firstname
            lastname
            postcode
            prefix
            region
            region_id
            street
            suffix
            telephone
            vat_id
          }
           status
        created_at
        grand_total
        is_guest_customer
          customer_name
          shipping_address {
            city
            street
            company
            country_code
            fax
            firstname
            lastname
            postcode
            prefix
            region
            region_id
            street
            suffix
            telephone
            vat_id
          }
         items {
          product_image_url
          selected_options{
            label
            value
          }
          quantity_ordered
          product_sku
          product_name
          product_sale_price{
            value
            currency
          }
          selected_options{
            label
            value
          }
          }
          increment_id
  country
  grand_total
  shipping_method
  payment_method
        }
        }
    `;
